import type { DraftPickAction } from "../types/actions";
import type { ValidationResult } from "../types/common";
import type { WarchestState } from "../types/game-state";

export function validateDraftPick(
  state: WarchestState,
  action: DraftPickAction,
): ValidationResult {
  if (state.phase !== "DRAFT") {
    return { valid: false, error: "Not in DRAFT phase" };
  }
  if (action.player !== state.activePlayer) {
    return { valid: false, error: "Not your turn to draft" };
  }
  const draftState = state.draftState;
  if (!draftState) {
    return { valid: false, error: "Draft state is missing" };
  }
  if (!draftState.availableUnits.includes(action.unitType)) {
    return { valid: false, error: "Unit is not available to draft" };
  }
  // Also verify it exists in config
  if (!state.config.units[action.unitType]) {
    return { valid: false, error: "Unknown unit type" };
  }
  return { valid: true };
}
